import { useState } from 'react';

/**
 * A marca na faixa.
 *
 * ── Duas regras, as mesmas do Labmanager e do gerador de PDF ─────────
 *
 * **Nunca uma marca aproximada.** Até a onda 172 esta função desenhava um
 * símbolo em SVG — um quadrado oliva com um trado laranja — que não é a
 * marca da Testesolo. Um cliente que abre o portal precisa reconhecer a
 * empresa no primeiro olhar; um símbolo parecido faz o contrário, levanta
 * a dúvida de estar no lugar certo. Agora é o arquivo oficial, o mesmo do
 * cabeçalho do laudo que ele recebe por e-mail. Se o arquivo não estiver
 * lá, a imagem some e só o texto fica — melhor sem marca que com uma que
 * não é a da casa.
 *
 * **Nunca recolorir a marca.** Ela é preta, desenhada para fundo claro. A
 * faixa é marrom-escura, então a marca recebe de volta a chapa creme para
 * a qual foi desenhada (`.marca-chapa`), em vez de ser invertida por
 * código: inverter transforma o símbolo num bloco sólido — o «T» e a
 * broca somem, porque são definidos por contraste de cor, não por
 * recorte. Havendo `marca/logo-testesolo-branca.png` no repositório, o
 * `prebuild` a publica e ela dispensa a chapa.
 */
export function Marca({ grande = false }: { grande?: boolean }) {
  /*
   * As duas versões oficiais, e o TEMA escolhe (onda 211): no claro a
   * colorida sobre a chapa creme; no escuro a branca (tirada da versão preta
   * oficial) sem chapa. Os tokens `--ts-marca-*` mostram uma e escondem a
   * outra — a mesma regra da bancada. A branca sai de
   * `marca/logo-testesolo-branca.png` pelo `gerar-marca.mjs`.
   */
  const [sumiu, setSumiu] = useState(false);
  return (
    <div className={`marca${grande ? ' marca-grande' : ''}`}>
      {!sumiu && (
        <span className="marca-chapa">
          <img className="marca-cor" src="/marca.png"
            alt="Testesolo — Engenharia geotécnica" onError={() => setSumiu(true)} />
          <img className="marca-branca" src="/marca-branca.png"
            alt="Testesolo — Engenharia geotécnica"
            onError={(e) => { e.currentTarget.style.display = 'none'; }} />
        </span>
      )}
      <div className="marca-sub">Portal do cliente</div>
    </div>
  );
}
